module.exports = __webpack_public_path__ + "static/media/member-club.648dc6ef.gif";